import React, { useCallback } from 'react';
import { useAtom, useAtomValue } from '@exodus/headless-ui';
import AssetInput from '../input/index.js';
import { INPUT_MODE } from '../../constants.js';
import { toAmountAtom, toAssetAtom, toFiatAmountAtom, isToLoadingAtom, } from '../../../atoms/index.js';
import useDeferLoading from '../../hooks/use-defer-loading.js';
const ToAssetInput = ({ Component, className, style, mode = INPUT_MODE.CRYPTO, disabled, onFocus, onBlur, debounceMs }, ref) => {
    const toAsset = useAtomValue(toAssetAtom);
    const [toAmount, setToAmount] = useAtom(toAmountAtom);
    const [toFiatAmount, setToFiatAmount] = useAtom(toFiatAmountAtom);
    const isLoading = useAtomValue(isToLoadingAtom);
    const resetAmount = useCallback(() => setToAmount(undefined), [setToAmount]);
    return (React.createElement(AssetInput, { ref: ref, Component: Component, className: className, style: style, mode: mode, direction: "to", asset: toAsset, amount: toAmount, fiatAmount: toFiatAmount, setFiatAmount: setToFiatAmount, setAmount: setToAmount, loading: useDeferLoading(isLoading), resetAmount: resetAmount, disabled: disabled, onFocus: onFocus, onBlur: onBlur, debounceMs: debounceMs }));
};
export default React.forwardRef(ToAssetInput);
